import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";

import VueSession from "vue-session";
import Vue2Filters from "vue2-filters";
import AsyncComputed from "vue-async-computed";

import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";

import "./styles/global.scss";
import store from "./store";
import { createProvider } from "./vue-apollo";

Vue.use(VueSession, { persist: true });
Vue.use(Vue2Filters);
Vue.use(AsyncComputed);
Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

new Vue({
  router,
  mixins: [Vue2Filters.mixin],
  store,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount("#app");
